import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CanDeactivateGuard } from 'src/app/shared/guards/can-deactivate.guard';

import { MerchantBasicDataComponent } from './components/merchant-basic-data/merchant-basic-data.component';
import { MerchantContactDataComponent } from './components/merchant-contact-data/merchant-contact-data.component';
import { MerchantMarketingDataEditComponent } from './components/merchant-marketing-data-edit/merchant-marketing-data-edit.component';
import { MerchantMarketingDataListComponent } from './components/merchant-marketing-data-list/merchant-marketing-data-list.component';
import { MerchantSitesComponent } from './components/merchant-sites/merchant-sites.component';
import { MerchantContainerComponent } from './containers/merchant-container/merchant-container.component';
import { MerchantSiteEditContainerComponent } from './containers/merchant-site-edit-container/merchant-site-edit-container.component';

const routes: Routes = [
  {
    path: '',
    component: MerchantContainerComponent,
    children: [
      {
        path: 'basic-data',
        component: MerchantBasicDataComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'contact-data',
        component: MerchantContactDataComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'sites',
        children: [
          {
            path: '',
            component: MerchantSitesComponent,
          },
          {
            path: 'create',
            component: MerchantSiteEditContainerComponent,
            canDeactivate: [CanDeactivateGuard],
          },
          {
            path: 'edit',
            component: MerchantSiteEditContainerComponent,
            canDeactivate: [CanDeactivateGuard],
          },
        ],
      },
      {
        path: 'marketing-data',
        children: [
          {
            path: '',
            component: MerchantMarketingDataListComponent,
          },
          {
            path: 'create',
            component: MerchantMarketingDataEditComponent,
            canDeactivate: [CanDeactivateGuard],
          },
          {
            path: 'edit',
            component: MerchantMarketingDataEditComponent,
            canDeactivate: [CanDeactivateGuard],
          },
        ],
      },
      { path: '**', redirectTo: 'basic-data' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MerchantRoutingModule {}
